import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationService } from '@/lib/services/notification.service';
import { i18n } from '@/shared/i18n';
import { logger } from '@/lib/utils/logger';
import { deleteExternalTool, deleteExternalToolCategory } from '../api';
import { EXTERNAL_TOOLS_QUERY_KEY, EXTERNAL_TOOL_CATEGORIES_QUERY_KEY } from './queryKeys';

export const useDeleteExternalToolCategoryWithCascade = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      categoryId,
      toolIds,
      workspaceId,
    }: {
      categoryId: string;
      toolIds: string[];
      workspaceId?: string;
    }) => {
      // First delete all associated tools
      await Promise.all(toolIds.map((toolId) => deleteExternalTool(toolId, workspaceId)));
      // Then delete the category
      await deleteExternalToolCategory(categoryId, workspaceId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [EXTERNAL_TOOLS_QUERY_KEY] });
      await queryClient.invalidateQueries({ queryKey: [EXTERNAL_TOOL_CATEGORIES_QUERY_KEY] });
      notificationService.showSuccess(
        i18n.t(
          'admin:externalTool.useDeleteExternalToolCategoryWithCascade.categoryAndAssociatedToolsDeleted',
        ),
      );
    },
    onError: (error) => {
      notificationService.showError(
        i18n.t(
          'admin:externalTool.useDeleteExternalToolCategoryWithCascade.failedToDeleteCategoryAnd',
        ),
      );
      logger.error('Failed to delete category with cascade:', error);
    },
  });
};
